export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('page:finish', () => {
		const {trackCollectOnly} = useEventWeb();
		trackCollectOnly('page_view', {});
	});
});
